// extracted by mini-css-extract-plugin
module.exports = {"root":"Subscription_root__K8xuI","margin":"Subscription_margin__1Xl1E"};